var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 77.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.0913,30.763L51.1833,0.3682l-0.0915-0.0417c-0.1175-0.0682-0.2419-0.124-0.3708-0.1667 c-0.2329-0.1307-0.5018-0.1833-0.7668-0.1501c-0.1302-0.0125-0.2614-0.0125-0.3917,0c-0.2538,0.0848-0.5015,0.1864-0.7417,0.3042 l-0.0915,0.0417L6.8338,30.7753c-0.9207,0.6903-1.1074,1.9963-0.4171,2.9169c0.3883,0.5178,0.9952,0.8257,1.6423,0.8335 c0.4426-0.003,0.8723-0.1492,1.2251-0.4167l6.4965-4.7088v46.3463c0,1.1507,0.9329,2.0835,2.0835,2.0835h64.2974 c1.1506,0,2.0835-0.9328,2.0835-2.0835V29.4918l6.4047,4.6463c0.9205,0.6961,2.2311,0.5143,2.9271-0.4063 c0.6963-0.9206,0.5143-2.2312-0.4062-2.9273l-0.0791-0.0542L93.0913,30.763z M57.2088,73.6839H42.8116V53.9194 c-0.104-3.9754,3.0345-7.2825,7.01-7.3864c3.9755-0.104,7.2824,3.0345,7.3865,7.0101c0.0003,0.0114,0.0005,0.023,0.0008,0.0346 c0,0.1126,0,0.2292,0,0.3417L57.2088,73.6839L57.2088,73.6839z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.220d33fa0c2690925264d929da8b0978.svg";
export { ForwardRef as ReactComponent };